import { Base } from "ui/Scripts/source/framework/base";
import { FrontToDoItem, IFrontToDoItem } from "./frontToDoItem";

export interface IFrontToDoItems {
    items: IFrontToDoItem[];
}

export class FrontToDoItems implements IFrontToDoItems {
    items: FrontToDoItem[];

    constructor();
    constructor(obj: IFrontToDoItems);
    constructor(obj?: any) {
        this.items = Base.getTypedArray(obj ? obj.items : null, FrontToDoItem);
    }
}